import { Path, Rect, Group } from "react-konva";

// Path extraído del SVG seat.svg (viewBox 0 0 512 512)
const SEAT_PATH =
  "M460.058,207.774v-89.116C460.058,53.103,406.904,0,341.349,0H170.651" +
  "C105.096,0,51.942,53.103,51.942,118.658v89.115c-27.208,0.753-49.469,23.185-49.469,50.669" +
  "v235.234c0,10.246,8.306,18.323,18.551,18.323H131.76c10.245,0,19.12-8.077,19.12-18.322v-5.176" +
  "h210.242v5.176c0,10.245,8.875,18.322,19.12,18.322h110.735c10.245,0,18.551-8.077,18.551-18.322" +
  "V258.444C509.527,230.959,487.266,208.527,460.058,207.774z" +
  "M113.778,474.899H39.575V258.444c0-7.502,6.103-13.574,13.604-13.574h46.426" +
  "c7.501,0,14.173,6.072,14.173,13.574V474.899z" +
  "M361.121,451.401H150.879v-92.754h210.242V451.401z" +
  "M361.121,258.444v35.894H150.879v-35.894c0-27.96-23.316-50.676-51.274-50.676H89.043v-89.11" +
  "c0-45.097,36.51-81.556,81.607-81.556h170.698c45.098,0,81.608,36.46,81.608,81.556v89.11h-10.562" +
  "C384.437,207.768,361.121,230.484,361.121,258.444z" +
  "M472.425,474.899h-74.203V258.444c0-7.501,6.672-13.574,14.173-13.574h46.426" +
  "c7.501,0,13.604,6.072,13.604,13.574V474.899z";

const SVG_SIZE = 512;

const COLORS = {
  selected:     '#3b82f6',
  disponible:   '#22c55e',
  // Reservado (hold temporal de otro comprador) y Ocupado (ya vendido) se ven
  // IGUAL a propósito: al cliente no le mostramos si un asiento está "a punto
  // de liberarse" o definitivamente vendido, para no generar falsas expectativas.
  noDisponible: '#9ca3af',
};

function seatColor(status, isSelected) {
  if (isSelected) return COLORS.selected;
  const s = (status ?? '').toLowerCase();
  if (s === 'reservado' || s === 'ocupado') return COLORS.noDisponible;
  return COLORS.disponible;
}

export default function Seat({
  x, y, number, onSelect, isSelected,
  rotation = 0, width, height, status,
}) {
  const color    = seatColor(status, isSelected);
  const scaleX = width  / SVG_SIZE;
  const scaleY = height / SVG_SIZE;

  return (
    <Group
      x={x}
      y={y}
      offsetX={width / 2}
      offsetY={height / 2}
      rotation={rotation}
      onClick={() => onSelect(number)}
      onTap={()   => onSelect(number)}
    >
      {/* Hitbox transparente — captura clics en toda la celda, no solo en el path */}
      <Rect
        width={width}
        height={height}
        fill="transparent"
      />

      {/* Forma del asiento — path del SVG escalado al tamaño del componente */}
      <Path
        data={SEAT_PATH}
        fill={color}
        scaleX={scaleX}
        scaleY={scaleY}
        opacity={isSelected ? 1 : 0.85}
        listening={false}
      />

    </Group>
  );
}
